const toggleDarkMode = ({ commit }, payload) => {
  commit('TOGGLE_DARK_MODE', payload);
};

export default {
  toggleDarkMode,
};
